const encode = (value: unknown): string => btoa(unescape(encodeURIComponent(JSON.stringify(value))));

const encodeAsciiJson = (value: unknown): string =>
	btoa(
		JSON.stringify(value).replace(
			/[\u0080-\uFFFF]/g,
			(unit) => `\\u${unit.charCodeAt(0).toString(16).padStart(4, "0")}`
		)
	);

const decode = <T>(base64Settings: string | null | undefined, fallback: T): T => {
	if (!base64Settings) return fallback;
	try {
		return JSON.parse(decodeURIComponent(escape(atob(base64Settings)))) as T;
	} catch {
		return fallback;
	}
};

const userAppSettingBlob = { decode, encode, encodeAsciiJson };

export default userAppSettingBlob;
